import { FIND_MICRO_TRANSACTION } from "../../routes";
import customAxios from "../../customAxios";
import { IFindMicroTransactions } from "../../../types/common.interface";

async function findMicroTransaction(props: IFindMicroTransactions) {
  var thisUrl = FIND_MICRO_TRANSACTION;

  let body: any = {
    populate: "factorsList",
    page: props?.page,
    limit: props?.limit,
    transactionId: props?.transactionId,
  };

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ GET_ALL_COMPANY: error });
  }
}

export default findMicroTransaction;
